/* eslint-disable max-len */
import { memo } from 'react';
import { Icon } from 'react-bootstrap-icons';

export const RegluingIcon: Icon = memo(({
  color = 'currentColor',
  size = '1em',
  title = null,
  ...rest
}) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14.3984 19.9784"
      width={ size }
      height={ size }
      fill={ color }
      { ...rest }
    >
      { title ? <title>{ title }</title> : null }

      <g>
        <rect height="19.9784" opacity="0" width="14.3984" x="0" y="0"/>
        <path d="M6.25781 3.77435L7.10938 4.47747L4.26562 4.47747C2.50781 4.47747 1.40625 5.3056 1.40625 6.61028C1.40625 7.93841 2.58594 8.83685 4.9375 9.07903L9.39062 9.54778C12.4219 9.85247 13.9922 11.2431 13.9922 13.3681C13.9922 15.4462 12.3984 16.7587 9.875 16.7587L4.94611 16.7587C5.00267 16.5549 5.03125 16.3398 5.03125 16.1181C5.03125 15.905 5.00453 15.6978 4.95134 15.5009L9.875 15.5009C11.6328 15.5009 12.7344 14.6728 12.7344 13.3681C12.7344 12.04 11.5469 11.1415 9.20312 10.8993L4.73438 10.4306C1.71094 10.1259 0.148438 8.73528 0.148438 6.61028C0.148438 4.53216 1.74219 3.21966 4.26562 3.21966L5.80469 3.21966C5.90625 3.42278 6.0625 3.61028 6.25781 3.77435Z" fill={ color }/>
        <path d="M2.51562 18.6415C3.90625 18.6415 5.03125 17.5087 5.03125 16.1181C5.03125 14.7353 3.90625 13.6025 2.51562 13.6025C1.125 13.6025 0 14.7353 0 16.1181C0 17.5087 1.125 18.6415 2.51562 18.6415ZM2.51562 17.415C1.79688 17.415 1.22656 16.8447 1.22656 16.1181C1.22656 15.3915 1.79688 14.829 2.51562 14.829C3.24219 14.829 3.80469 15.3915 3.80469 16.1181C3.80469 16.8447 3.25 17.415 2.51562 17.415Z" fill={ color }/>
        <path d="M9.69531 2.90716L11.1328 2.90716C12.1328 2.90716 12.8906 3.45403 12.8906 4.50091C12.8906 5.57122 12.1562 6.21966 11.125 6.21966L10.1641 6.21966C9.85938 6.21966 9.59375 6.41497 9.59375 6.75872C9.59375 7.09466 9.85938 7.28997 10.1875 7.28997L11.125 7.28997C12.7734 7.28997 13.9922 6.2431 13.9922 4.54778C13.9922 2.8681 12.7812 1.83685 11.1328 1.83685L9.69531 1.83685L9.69531 0.53216C9.69531 0.0946597 9.29688-0.170965 8.9375 0.12591L6.75781 1.92278C6.42969 2.20403 6.42188 2.53997 6.75781 2.82903L8.9375 4.61028C9.29688 4.90716 9.69531 4.66497 9.69531 4.21185Z" fill={ color }/>
      </g>
    </svg>
  );
});
